import React, { useMemo, useState } from 'react';
import { Platform, Pressable, StyleSheet, View } from 'react-native';
import FontAwesome6 from '@expo/vector-icons/FontAwesome6';
import PropTypes from 'prop-types';
import { H6, Paragraph2 } from '../text';

export const Dropdown = ({ iconColor = '#000', includeSelection = true, label, labelStyle, options, onSelect, selection, selectionStyle }) => {
    const [isOpen, setIsOpen] = useState(false);
    const iconName = useMemo(() => {
        if (Platform.OS.equals('web')) {
            if (isOpen) {
                return 'caret-up';
            } else {
                return 'caret-down';
            }
        } else {
            if (isOpen) {
                return 'filter-circle-xmark';
            } else {
                return 'filter';
            }
        }
    }, [isOpen]);

    const renderOptions = () => {
        // if (Platform.OS.equals('web')) {
        return (
            <View key={`${label}-options-wrapper`} style={StyleSheet.flatten(Styles.optionsContainer, { borderColor: iconColor })}>
                {options?.map((option, index) => {
                    return (
                        <Pressable
                            key={`${label}-opt-${option.key}`}
                            onPress={() => {
                                onSelect(option.value || option.id);
                                setIsOpen(false);
                            }}
                        >
                            <H6 style={StyleSheet.flatten(Styles.optionText, { color: iconColor })} text={option.label} />
                        </Pressable>
                    );
                })}
            </View>
        );
        // } else {
        //     //TODO implement bottom sheet
        // }
    };

    return (
        <View>
            <Pressable onPress={() => setIsOpen(val => !val)} style={Styles.wrapper}>
                <Paragraph2 extraStyle={StyleSheet.flatten(Styles.labelText, labelStyle)} text={label} />
                {includeSelection && <Paragraph2 extraStyle={StyleSheet.flatten(Styles.labelText, labelStyle, selectionStyle)} text={selection} />}

                <FontAwesome6 name={iconName} size={20} color={iconColor} style={{ marginLeft: 5 }} />
            </Pressable>
            {isOpen && renderOptions()}
        </View>
    );
};

const Styles = StyleSheet.create({
    labelText: {
        fontFamily: 'GothamBook',
        fontSize: Platform.OS.equals('web') ? '16pt' : 16,
        paddingRight: 5
    },
    optionsContainer: {
        backgroundColor: 'transparent',
        borderRadius: 5,
        borderWidth: 1
    },
    optionText: {
        color: '#162b4a',
        fontFamily: 'GothamBook',
        fontSize: Platform.OS.equals('web') ? '12pt' : 12,
        marginLeft: 10,
        marginVertical: 5
    },
    wrapper: {
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'space-evenly'
    }
});

Dropdown.propTypes = {
    iconColor: PropTypes.string,
    label: PropTypes.string,
    labelStyle: PropTypes.object,
    options: PropTypes.array.isRequired,
    onSelect: PropTypes.func.isRequired,
    selection: PropTypes.string,
    selectionStyle: PropTypes.object
};
